import React from 'react';
import PropTypes from 'prop-types';

import styles from './Checkbox.module.scss';

const Checkbox = ({ id, change, checked, disabled }) => (
    <input
        disabled={disabled}
        className={styles['checkbox-component']}
        type={'checkbox'}
        id={id || ''}
        checked={checked || false} onChange={(e) => change && change({ id, checked: e.target.checked })}
    />
);

Checkbox.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    change: PropTypes.func,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default Checkbox;
